package com.wintermar.inspection.feature.domain.usecase.reference

import com.wintermar.inspection.core.data.AppSetting
import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.feature.domain.model.auth.UserModel
import com.wintermar.inspection.feature.domain.repository.ReferenceRepository
import com.wintermar.inspection.util.Constant
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.onEach

class GetProfileUseCase(
    private val referenceRepository: ReferenceRepository,
    private val appSetting: AppSetting
) {
    operator fun invoke(): Flow<FlowResult<UserModel>> {
        return referenceRepository.getProfile().onEach { result ->
            if (result is FlowResult.Success) {
                result.data?.let {
                    appSetting.apply {
                        setToken(
                            userId = it.userId,
                            userFullName = it.fullName
                        )

                        setAccess(
                            inspectionAccess = it.listAccess.contains(Constant.INSPECTION_ACCESS),
                            templateAccess = it.listAccess.contains(Constant.TEMPLATE_ACCESS)
                        )
                    }
                }
            }
        }
    }
}
